<template>
	<div id="contact" class="mb-5">
		<div class="container">
			<hr class="hr-black">
			<div class="row pt-5">
				<div class="col-12 pb-5 text-center links-black">
					<h5 class="mb-4">
						Skontaktuj się
					</h5>
					<div class="row links-black">
						<div class="col-12 col-lg-5 offset-lg-1">
							<div class="d-flex align-items-center justify-content-center">
								<img src="/assets/images/old-phone.svg" alt="" class="d-inline-block mr-3 mb-2">
								<a href="tel:228121949" class="h2 fw-500" @click="phoneTracking('228-121-949')">228-121-949</a>							
							</div>
						</div>
						<div class="col-12 col-lg-5">
							<div class="d-flex align-items-center justify-content-center">
								<img src="/assets/images/old-phone.svg" alt="" class="d-inline-block mr-3 mb-2">
								<a href="tel:530330300" class="h2 fw-500" @click="phoneTracking('530-330-300')">530-330-300</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row pb-5">
				<div class="col-12 text-center links-black" @click="emailTracking" v-html="fillEmail()">
				</div>
			</div>
			<hr class="hr-black">
			<div class="row py-5">
				<div class="col-12 col-lg-8 offset-lg-2">
					<Form />
				</div>
			</div>
			<hr class="hr-black">
		</div>
	</div>
</template>

<script>
	
	import Form from '@/components/Form.vue';
	export default{
		components: {
			Form
		},
		methods: {
			fillEmail (){
				let part1 = "biuro",
					part2 = Math.pow(2,6),
					part3 = String.fromCharCode(part2),
					part4 = "ango.waw.pl",
					part5 = part1 + String.fromCharCode(part2) + part4;

				return '<a href="' + 'mai' + 'lto' + ':' + part5 + '" class="h5 fw-500">' + part1 + part3 + part4 + '</a>';
			},
			phoneTracking(number) {
				this.$gtag.event('Wybranie numeru', {
					'event_category': 'Zadzwoń do nas',
					'event_label': number,
					'non_interaction': false
				})
			},
			emailTracking() {
				this.$gtag.event('Kliknięcie w email', {
					'event_category': 'E-mail',
					'event_label': 'biuro@ango.waw.pl',
					'non_interaction': false
				})
			}
		}
	}
</script>